/**
 * SearchLA, subclass of SearchInterface
 * requires backbone.js
 */

var SearchLA = SearchInterface.extend({
	/** @lends SearchLA.prototype */


	/**
	 * Set the interface's config options
	 * @param {Object} config
	 * @param {Int} config.iid LA iid
	 * @param {Boolean} config.isDefaultGroup is this the default search all groups page (only false in some LA group pages)
	 * @param {Array} config.group_id_default default group limit for this page (only set in LA)
	 * @param {Object} config.group_data all the groups data
	 * @param {Array} config.groups_available all the groups the user can access (only set in LA)
	 * @param {Bool} config.display_facets are we displaying facet limiters
	 * @param {Object} config.facets facet limiters for current search
	 * @param {Object} config.sort sorting for current search
	 * @param {Object[]} config.sort_options options for sorting the results
	 * @param {String} config.sort_options[].field name of sorting field
	 * @param {String} config.sort_options[].dir direction of sort (asc/desc)
	 * @param {String} config.sort_options[].label human readable name of sorting field
	 * @param {Object} [config.query_facet_results] facets data returned for current search
	 * @param {Object} config.searchwt weight for various search fields
	 */
	setConfig: function(config) {
		var defaults = {
			iid: 0,
			isDefaultGroup: true,
			group_id_default: [],
			groups_available: [],
			group_data: {},
			display_facets: true,
			facets: {
				topics: [],
				keywords: [],
				g: []
			},
			sort: { field: '_score', dir: 'desc' },
			sort_options: [
				{ field: '_score', dir: 'desc', label: this.get('lang').srch_sortlabelrel },
				{ field: 'updated', dir: 'desc', label: this.get('lang').srch_sortlabeldatedesc },
				//{ field: 'updated', dir: 'asc', label: this.get('lang').srch_sortlabeldateasc }
			],
			query_facet_results: {},
			facet_results: {},
			searchwt: { question: '6', details: '3', topics: '4', keywords: '5', allInOne: '1' }
		};

		_.extend(defaults, config);
		_.each(defaults, function(v,k,l){
			this.set(k, v, { silent: true });
		}, this);


		//if groups_available is still [] then add all public group_data to it
		if (this.get('groups_available').length === 0) {
			var ga = [];
			_.each(this.get('group_data'), function(v,k){
				ga.push(v.id);
			}, this);
			this.set('groups_available', ga);
		}

		if (this.get('group_id_default').length === 0) {
			this.set('group_id_default', this.get('groups_available'));
		}

		this.set('selector', '#s-srch-source-'+this.get('id'), { silent: true });

		if (this.get('group_id_default').length === 1) {
			this.setLAFacet({ facet: 'g', value: this.get('group_id_default')[0] });
		}

		//Listen for facets set form the controller's query string
		this.listenTo(searchcontroller, "facet:set", this.setLAFacet);
	},
	/**
	 * Set a facet without initiating a query or overwriting other facets
	 * used to set facets from query string by controller
	 * @param {Object} d data
	 * @param {String} d.facet name of facet
	 * @param {String} d.value value of facet to set
	 */
	setLAFacet: function(d) {
		if (d.facet && d.facet !== '' && d.value && d.value !== '') {
			//make sure we are only setting LA facets.
			if ( this.get('facets')[d.facet] ) {
				this.setFacet(d.facet, d.value, false, false);
			}
		}
	},
	/**
	 * Render the views
	 */
	renderViews: function() {
		var $container = jQuery(this.get('selector'));
		var views = []; //array of rows with views in them

		var searchheader = new SearchHeader({ model: this, id: 's-srch-header-'+this.get('id') });
		if (searchcontroller.get('layout') !== 'bento') {
			var top_pagination = new PaginationView({ model: this, id: 's-srch-paginate-'+this.get('id')+'-top', location: 'top' });
			var searchfooter = { '$el': '' };
		} else {
			var top_pagination = { '$el': '' };
			var searchfooter = new SearchFooter({ model: this, id: 's-srch-footer-'+this.get('id') });
		}
		var bottom_pagination = new PaginationView({ model: this, id: 's-srch-paginate-'+this.get('id')+'-bottom', location: 'bottom' });
		var params = new LACurrentParamsView({ model: this, id: 's-srch-params-'+this.get('id') });
		var resultslist = new LAResultsList({ model: this, id: 's-srch-results-'+this.get('id') });
		var askform = new AskView({ model: this, formType: 'noresults', alert_text: this.get('lang').srch_notasked, source: this.get('id') });

		if (this.get('description') !== '') {
			views.push(
				jQuery('<div class="row"></div>').append(
					jQuery('<div>').addClass('col-sm-12 s-srch-description').attr('id', 's-srch-description-'+this.get('id')).append(
						jQuery('<p>').html(this.get('description'))
					)
				)
			);
		}

		views.push( jQuery('<div class="row"></div>').append([searchheader.$el, top_pagination.$el]) );
		if (searchcontroller.get('layout') !== 'bento') {
			views.push( jQuery('<div class="row"></div>').append(params.$el) );
		}
		views.push( jQuery('<div class="row"></div>').append(resultslist.$el) );
		views.push( jQuery('<div class="row"></div>').append([searchfooter.$el, bottom_pagination.$el]) );
		views.push( jQuery('<div class="row"></div>').append(askform.$el) );

		if (this.get('display_facets') === true) {
			var $col1 = jQuery('<div class="col-md-9"></div>').append(views);
			var $col2 = jQuery('<div class="col-md-3"></div>');

			//facet views
			var facetviews = [];
			_.each(this.get('facets'), function(v,k,l){
				facetviews.push( new LAFacetView({ model: this, id: 's-srch-facet-'+this.get('id')+'-'+k, facetType: k }) );
			}, this);
			_.each(facetviews, function(v,k){
				$col2.append(v.$el);
			}, this);
			$container.append( jQuery('<div class="row"></div>').append($col1, $col2) );
		} else {
			$container.append( views );
		}
	},
	/**
	 * Generate the query object for the search
	 * override in subclass
	 * sets the query_obj attribute
	 * @param {Boolean} [autocomp] is this an autocomplete request
	 */
	buildQuery: function(autocomp) {
		if (typeof autocomp == 'undefined') {
			autocomp = false;
		}

		qo = {
			search_source_id: this.get('id'),
			rows: this.get('perpage'),
			iid: this.get('iid'),
			searchwt: JSON.stringify(this.get('searchwt'))
		};

		//facets
		var facets = this.get('facets');

		//build the group params
		if (facets.g && facets.g.length > 0) {
			var group_ids = [];
			_.each(facets.g, function(v){
				if (this.get('groups_available').indexOf(v) == -1) { return; } //keep people from searching groups they shouldn't
				group_ids.push(v);
			}, this);
			qo.group_ids = group_ids;
		} else if (this.get('group_id_default').length > 0) {
			qo.group_ids = this.get('group_id_default');
		} else {
			qo.group_ids = this.get('groups_available');
		}
		qo.group_ids = JSON.stringify(qo.group_ids);

		var page = this.get('page');
		qo.start = (qo.rows * (page - 1));

		//we skip some stuff for autocomplete
		if (!autocomp) {
			_.each(facets, function(v,k,l){
				if (k == 'g') { return; }
				var facetquery = '';
				if (v.length > 0) {
					qo[k] = JSON.stringify(v);
				}
			}, this);

			qo.q = this.convertSearch();

			var s = this.get('sort');
			qo.sort = s.field+' '+s.dir;

			this.set('query_obj', qo);
		} else {
			qo.facet = false;
			return qo;
		}
	},
	/**
	 * Take the typed query and fancy it up for use by the API
	 * override in subclass
	 */
	convertSearch: function() {
		//maybe we need to escape (with a backslash \ ) some characters: + - && || ! ( ) { } [ ] ^ " ~ * ? : \ /
		var typed = this.get('query_typed');
		return typed;
	},
	/**
	 * Request the data (an ajax request)
	 */
	requestData: function() {
		var self = this;

		workingAlert();

		$.ajax({
		  url: this.protocol+'//'+this.get('request_url'),
		  data: this.get('query_obj'),
		  success: function(d, status){
		  	  clearTimeout(requestError);
 			  self.cacheResults(d);
			  self.parseResults(d);
			  self.setFocus();
			  stopAlert();
		  },
		  dataType: 'jsonp',
		});

		var requestError = setTimeout(function() {
		   // Handle error accordingly
		   errorAlert();
		}, 10000);

		//record query spy if available
		if (typeof springSpace.querySpy !== 'undefined') {
			try {
				var q = this.get('query_typed');
				if (q == '' || q == '*:*') { return; }
				springSpace.querySpy.record({ query: q });
			} catch(e) {
				searchcontroller.debug(e);
			}
		}
	},
	/**
	 * Update the facets only for query string or group change.
	 * Facets are returned based on query string and group only.
	 */
	retrieveFacets: function() {
		qo = {
			search_source_id: this.get('id'),
			rows: 0,
			iid: this.get('iid'),
			searchwt: JSON.stringify(this.get('searchwt'))
		};

		//facets
		var facets = this.get('facets');

		if (facets.g.length > 0) {
			var group_ids = [];
			_.each(facets.g, function(v,k,l){
				group_ids.push(v);
			}, this);
			qo.group_ids = group_ids;
		} else {
			var g_avail = this.get('groups_available');
			if (g_avail.length == 1) {
				qo.group_ids = [g_avail[0]];
			} else if (this.get('group_id_default').length > 0) {
				qo.group_ids = this.get('group_id_default');
			} else {
				qo.group_ids = g_avail;
			}
		}
		qo.group_ids = JSON.stringify(qo.group_ids);

		qo.q = this.convertSearch();

		if (this.facetCache[jQuery.param(qo, true)]) {
			this.parseFacets(this.facetCache[jQuery.param(qo, true)]);
			return;
		}

		var self = this;

		$.ajax({
		  url: this.protocol+'//'+this.get('request_url'),
		  data: qo,
		  success: function(d, status){
		  	  //clearTimeout(requestError);
 			  self.cacheFacets(jQuery.param(qo, true), d);
			  self.parseFacets(d);
		  },
		  dataType: 'jsonp',
		});
	},
	/**
	 * Apply facet data retrieved from Solr
	 */
	parseFacets: function(data) {
		this.set('facet_results', data.facets);
		this.trigger('facets:retrieve');
	},
	/**
	 * Grab the results and trigger some actions on the various views
	 * @param {Object} data returned from solr query
	 */
	parseResults: function(data) {
		this.set({
			'results': data.results,
			'total_results': data.total_results,
			'query_facet_results': data.facets
		});
		if (data.total_results == 0) {
			this.trigger('search:noresults');
		} else {
			this.trigger('search:retrieve');
		}
		if (this.get('display_facets')) {
			this.retrieveFacets();
		}
	}

});


//!LAResultsList View
var LAResultsList = ResultsList.extend(
/** @lends ResultsList.prototype */
{

	events: {
		'click .s-srch-result-subj a': 'setFacet',
		'click .s-srch-result-title a': 'gotoAnswer',
		'contextmenu .s-srch-result-title a': 'gotoAnswer',
	},
	/**
	 * render the results
	 */
    render: function () {
    	var $list = $('<ul class="list-unstyled s-srch-results"></ul>');
		var results = this.model.get('results');
		if(results.length > 0) {
			_.each(results, function(v){
				$list.append(this.resultItem(v));
			}, this);
		}
		this.$el.html($list);

		try {
        	if (window.self !== window.top) {
	        	//in iframe add target to FAQ links
	        	$('.s-la-faq-listing-q a').attr('target', '_parent');
        	}
		} catch (e) { }

		return this;
    },
    /**
     * When no results are retrieved empty results list. No results alert/form will appear.
     */
    noResults: function() {
    	$(this.el).html('');
    	return this;
    },
	/**
	 * Show the result
	 * @param {Object} item result object
	 * @param {Int} item.group_id group id
	 * @param {Int} item.faqid faq id
	 * @param {Array} item.keywords_text the keywords
	 * @param {Array} item.topics_text topic names only
	 * @param {String} item.question
	 * @param {String} item.updated last updated date
	 * @param {Int} item.s LA iid
	 * @return {Object} jQuery object
	 */
	resultItem: function(item) {
		var $li = $('<li></li>').addClass('s-srch-result');
		var html = '';

		if (!item.faqid || !item.group_id || !item.question) { return ''; }

		var domain = ( this.model.get('site_url') == '' ? '/' : '//' + this.model.get('site_url') );

		var qurl = (this.model.get('group_data')[item.group_id].slug == '') ? 'faq/'+item.faqid : this.model.get('group_data')[item.group_id].slug+'/faq/'+item.faqid;

		item.url = ( domain == '/' ? domain : domain + '/' ) + qurl;
		if (!item.updated_formatted) {
			var date = new Date(item.updated);
			item.updated_formatted = date.format(this.model.get('lang').Dt_DateTime);
		}
		item.topics_text = (item.topics_text) ? item.topics_text : [];

		if (this.model.get('item_template') === '') {
			if (searchcontroller.get('layout') == 'bento') {
				this.model.set('item_template',
				'<div class=s-srch-result-title>'+
					'<a href="{{url}}" data-faqid={{faqid}}>{{question}}</a>'+
				'</div>'+
				'<div class="s-srch-result-meta">'+
					'<span class="s-srch-result-date"><span class=metalabel>'+this.model.get('lang').srch_update+'</span> {{updated_formatted}}</span>'+
					'{{# if (topics_text.length > 0) { }}'+
						'<span class="divider" aria-hidden="true">|</span><span class="s-srch-result-subj">'+
							'<span class=metalabel>'+this.model.get('lang').srch_topic+'</span>'+
							'<ul class="list-inline metavalue" aria-label="'+this.model.get('lang').srch_topic+'">'+
								'{{# _.each(topics_text, function(v,k){ }}'+
									'<li>{{v}}'+
									'{{# if (k+1 < topics_text.length){ print(\';\'); } }}'+
									'</li>'+
								'{{# }); }}'+
							'</ul>'+
						'</span>'+
					'{{# } }}'+
				'</div>',
				{ silent: true });
			} else {
				this.model.set('item_template',
				'<div class=s-srch-result-title>'+
					'<a href="{{url}}" data-faqid={{faqid}}>{{question}}</a>'+
				'</div>'+
				'<div class="s-srch-result-meta">'+
					'<span class="s-srch-result-date"><span class=metalabel>'+this.model.get('lang').srch_update+'</span> {{updated_formatted}}</span>'+
					'{{# if (topics_text.length > 0) { }}'+
						'<span class="divider" aria-hidden="true">|</span><span class="s-srch-result-subj">'+
							'<span class=metalabel>'+this.model.get('lang').srch_topic+'</span>'+
							'<ul class="list-inline metavalue" aria-label="'+this.model.get('lang').srch_topic+'">'+
								'{{# _.each(topics_text, function(v){ }}'+
									'<li><span class="label label-default"><a href="#" data-topic="{{{v}}}">{{v}}</a></span></li>'+
								'{{# }); }}'+
							'</ul>'+
						'</span>'+
					'{{# } }}'+
				'</div>',
				{ silent: true });
			}
		}

		if (this.item_template === '') {
			this.item_template = _.template( this.model.get('item_template') );
		}

		try {
			html = this.item_template(item);
		} catch(e) {
			//Error
			searchcontroller.debug(e);
			return '';
		}
		return $li.html( html );
	},
	/**
	 * Clicking on a result title updates query spy
	 */
	gotoAnswer: function(e) {
		var faqid = $(e.currentTarget).attr('data-faqid');
		if (!!faqid) {
			if (typeof springSpace.querySpy !== 'undefined') {
				try {
					var q = this.model.get('query_typed');
					if (q == '' || q == '*:*') { return; }
					springSpace.querySpy.gotoFAQ({ faqid: faqid });
				} catch(e) {
					searchcontroller.debug(e);
				}
			}
		} else {
			searchcontroller.debug('no faqid');
		}
		return true;
	},
	/**
	 * Clicking on a topic in the results sets that topic as the only facet filter
	 */
	setFacet: function(e) {
		e.preventDefault();
		var topic = $(e.currentTarget).attr('data-topic');
		this.model.setFacet('topics', topic);
	}

});

//!LACurrentParamsView
var LACurrentParamsView = CurrentParamsView.extend(
/** @lends LACurrentParamsView.prototype */
{
	/**
	 * create the display
	 */
	render: function() {

		this.$el.html('');
		var $container = jQuery('<div></div>').addClass('s-srch-params').attr({ 'aria-live': 'polite', 'aria-relevant': 'text' });

		var facetData = this.model.get('facets');

		var links = [];
		//iterate the facet types
		_.each(facetData, function(f, t){
			if (f.length > 0) {
				//iterate the values on the specific facet
				$li = $('<li></li>');
				if (t == 'g') {
					//show nothing if they only have one group available
					if (this.model.get('groups_available').length == 1) {
						return;
					}
					//dont show full default list
					if (this.model.get('isDefaultGroup') === true && compareArrays(this.model.get('group_id_default'), f)) {
						$li.append('<span>'+this.model.get('lang')['srch_filters_g']+':</span> All');
						links.push($li);
						return;
					}
				}

				$li.append('<span>'+this.model.get('lang')['srch_filters_'+t]+':</span> ');
				var html = ' ';
				_.each(f, function(v,k,l) {
					var f_value = (t == 'g') ? this.model.get('group_data')[v].name : v;
					html += '"'+f_value+'"';
					if (l.length > (k + 1)) {
			    	 	html += ' OR ';
		    	    }
				}, this);

				if (f.length > 1) {
					html = '('+html+')';
				}
				var $filterNames = $('<span></span>').text(html);
        		$li.append($filterNames);
				links.push($li);
			}
		}, this);

		//add a remove all link if appropriate
		if (links.length > 0) {
			$li = $('<li></li>').append(
		    	        $('<a href="#" class="removeAll" aria-controls="s-srch-results-'+this.model.get('id')+'"></a>')
		    	        .html('<i class="fa fa-times-circle"></i> '+this.model.get('lang').srch_facetremoveall)
		    	    );
			links.push($li);
		}

		if (links.length > 0) {
			this.$list = $('<ul class="list-inline"></ul>');

			_.each(links, function(v){
				this.$list.append(v);
			}, this);

			$container.append(['<h3>'+this.model.get('lang').srch_filtercurr+'</h3>', this.$list]);
			this.$el.append($container).removeClass('hidden');
		} else {
			this.$el.addClass('hidden');
		}
		return this;
	}

});


//!LAFacetView
var LAFacetView = FacetView.extend(
/** @lends LAFacetView.prototype */
{

	/**
	 * create the display
	 */
	render: function() {
		searchcontroller.debug('LAFacetView render');
		searchcontroller.debug(this.facetType);
		switch(this.facetType) {
			case 'g':
				this.makeLabel = function(v) {  return this.model.get('group_data')[v].name; }
				this.facetSelected = function(v) { return (this.model.get('facets')[this.facetType].indexOf( v.toString() ) > -1) }
				break;
			default:
				this.makeLabel = function(name) {
					return name;
					//return name.capitalize();
				}
				this.facetSelected = function(v) { return (this.model.get('facets')[this.facetType].indexOf(v) > -1) }
		}
		this.header = this.model.get('lang')['srch_filters_'+this.facetType];

		this.$el.html('');
		this.$el.append('<h3><button class="btn btn-default s-srch-facet-btn" type=button data-toggle="collapse" data-target="#s-srch-'+this.model.get('id')+'-cloud-'+this.facetType+'"><span class="s-srch-side-collapse"><i class="fa fa-caret-down"></i></span> '+this.header+'</button></h3>');

		this.$list = $('<ul class="s-srch-cloud list-unstyled collapse in" id="s-srch-'+this.model.get('id')+'-cloud-'+this.facetType+'"></ul>');
		this.$el.append(this.$list);

		return this;
	},

	/**
	 * Generate the list of facet values
	 */
	makeList: function() {
		this.$list.empty();

		var facetData = this.model.get('facet_results');
		var curFacets = this.model.get('facets')[this.facetType];
		var list = [];

		// for groups facet show all groups all the time.
		if (this.facetType === 'g') {
			_.each(this.model.get('groups_available'), function(v){
				var checked = this.facetSelected(v);
				var $li = $('<li></li>');
				var $label = $('<label class="check"></label>');
				var $input = $('<input type="checkbox" />').attr('name', v).prop('checked', checked).attr('aria-controls', 's-srch-results-'+this.model.get('id'));

				var cur = _.find(facetData[this.facetType], function(f) { return f.value == v; });
				var count = (cur && cur.count) ? ' ('+cur.count+')' : '';
				$label.append([$input, ' '+this.makeLabel(v)+count]);
				$li.append($label);

				list.push($li);
			}, this);
		} else {

			if (facetData[this.facetType] && facetData[this.facetType].length > 0) {
				_.each(facetData[this.facetType], function(v) {
					var checked = this.facetSelected(v.value);
					var $li = $('<li></li>');
					var $label = $('<label class="check"></label>');
					var $input = $('<input type="checkbox" />').attr('name', v.value).prop('checked', checked).attr('aria-controls', 's-srch-results-'+this.model.get('id'));

					$label.append($input).append(' '+this.makeLabel(v.value)+' (' + v.count +')');
					$li.append($label);

					list.push($li);
				}, this);
			}
		}

		if (list.length == 0) {
			this.$list.append('<li>'+this.model.get('lang').srch_facetnone+'</li>');
		} else {
			_.each(list, function(v){
				this.$list.append(v);
			}, this);
		}
	},

});
